import { CalendarCheck, Fish, MapPin, Utensils } from "lucide-react";
import { MaskReveal, Reveal } from "./Reveal";
import { PHOTO_SIZES, PHOTOS } from "./images";

const HIGHLIGHTS = [
  {
    icon: CalendarCheck,
    title: "Open year-round",
    body: "Weekend trips, winter seasons and long stays — we never close.",
  },
  {
    icon: Fish,
    title: "Minutes from Falcon Lake",
    body: "Known within the fishing community, with public boat access nearby.",
  },
  {
    icon: MapPin,
    title: "Right in Zapata",
    body: "Off U.S. Hwy 83, an easy drive to Laredo and the Rio Grande Valley.",
  },
  {
    icon: Utensils,
    title: "Texan & Mexican culture",
    body: "Local food, music and seasonal events on both sides of the heritage.",
  },
];

export function Intro() {
  const main = PHOTOS.cabinRow;
  const detail = PHOTOS.sign;

  return (
    <section
      className="texture-paper bg-background py-24 sm:py-28 lg:py-36"
      aria-labelledby="intro-title"
    >
      <div className="mx-auto grid max-w-[1400px] gap-14 px-4 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-20 lg:px-10">
        <div className="relative">
          <MaskReveal className="media-zoom rounded-sm">
            <img
              src={main.src}
              srcSet={main.srcSet}
              sizes={PHOTO_SIZES.half}
              alt={main.alt}
              width={main.width}
              height={main.height}
              loading="lazy"
              decoding="async"
              className="aspect-[4/3] w-full rounded-sm object-cover"
            />
          </MaskReveal>

          <div className="intro-float-in absolute -bottom-10 -right-4 w-40 overflow-hidden rounded-sm border-4 border-background shadow-[var(--shadow-lift)] sm:-right-8 sm:w-56 lg:w-64">
            <img
              src={detail.src}
              srcSet={detail.srcSet}
              sizes={PHOTO_SIZES.inset}
              alt={detail.alt}
              width={detail.width}
              height={detail.height}
              loading="lazy"
              decoding="async"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
        </div>

        <div className="mt-12 lg:mt-0">
          <Reveal>
            <p className="eyebrow text-clay">Welcome to Amigo Inn</p>
            <h2
              id="intro-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Stay Awhile in Zapata
            </h2>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground sm:text-lg">
              Amigo Inn &amp; RV Park offers a peaceful, down-home place to stay near Falcon Lake.
              Whether you are visiting for a fishing trip, escaping the winter, working in the
              region, gathering with family, or planning a longer stay, you will find comfortable
              accommodations and genuine South Texas hospitality.
            </p>
          </Reveal>

          <ul className="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-2">
            {HIGHLIGHTS.map((item, i) => (
              <Reveal as="li" key={item.title} delay={i * 0.07} className="rule-sand pt-5">
                <p className="flex items-center gap-2.5 font-display text-lg text-forest-deep">
                  <item.icon className="size-4.5 shrink-0 text-forest" aria-hidden="true" />
                  {item.title}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
